<script setup lang="ts">
import { Analytics } from '@vercel/analytics/nuxt'

const colorMode = useColorMode()
const themeColor = computed(() => (colorMode.value === 'dark' ? '#0b1220' : '#ffffff'))

const siteName = 'PureJoule'
const siteUrl = 'https://purejoule.com' // <-- cambia con il tuo dominio reale
const defaultTitle = 'PureJoule — Coaching endurance per atleti amatori'
const defaultDescription
  = 'Coaching data-driven per atleti amatori: allenamenti su misura, progressione sostenibile e supporto continuo. Every joule matters.'

useHead({
  htmlAttrs: { lang: 'it-CH' },
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    { name: 'theme-color', content: themeColor.value },

    // Buone pratiche SEO
    { name: 'robots', content: 'index,follow' },
    { name: 'application-name', content: siteName }
  ],
  link: [
    // favicon standard (consiglio: metterla in /public/favicon.ico)
    { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' },

    // canonical generico (poi lo sovrascrivi per pagina se vuoi)
    { rel: 'canonical', href: siteUrl }
  ]
})

// Default SEO per tutto il sito (le pagine possono sovrascrivere)
useSeoMeta({
  title: defaultTitle,
  description: defaultDescription,

  // Open Graph
  ogSiteName: siteName,
  ogTitle: defaultTitle,
  ogDescription: defaultDescription,
  ogType: 'website',
  ogLocale: 'it_CH',
  ogUrl: siteUrl,
  ogImage: `${siteUrl}/og/purejoule-og.jpg`, // <-- crea questo asset in /public/og/

  // Twitter
  twitterCard: 'summary_large_image',
  twitterTitle: defaultTitle,
  twitterDescription: defaultDescription,
  twitterImage: `${siteUrl}/og/purejoule-og.jpg`
})
</script>

<template>
  <UApp>
    <Analytics />
    <NuxtLoadingIndicator />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
